module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.89e8e911.jpg";